import { MAP_TYPES } from '@deck.gl/carto';

const SLR3_4FEET_SOURCE_ID = 'slr3_4FeetSource';

const source = {
  id: SLR3_4FEET_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT * FROM `us-con-gcp-npr-0000424-011325.diamond.NOAA_Sea_Level_Rise` WHERE Relative_Sea_Level_Rise_Feet = 3.4',
  geoColumn: 'geom',
};

export default source;